module.exports = __webpack_public_path__ + "img/unionpay.de40282f.svg";